import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  warnHtmlInMessage: 'off',
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

// Back-compat shim: a number of non-component modules (e.g. SidebarItems.js,
// adp.js) import this file and call `i18n.t(...)` or set `i18n.locale` directly.
// In vue-i18n 9 those live on `i18n.global`, so proxy them here.
i18n.t = (...args) => i18n.global.t(...args)
Object.defineProperty(i18n, 'locale', {
  get() {
    return i18n.global.locale
  },
  set(v) {
    i18n.global.locale = v
  },
})

export default i18n
